import { useIntl, FormattedMessage } from 'react-intl';
import { Style } from '@/components/style';
import { img } from '@/assets';
import PropTypes from 'prop-types';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { setDelivrableAction } from '@/actions/uberDirect/uberDirectAction';
import { useEffect } from 'react';

const { alertColor, blackColor, primaryColor } = new Style().getUiConfig();

function DeliveryMethodSelector({ deliveryMethod, setDeliveryMethod }) {
  const intl = useIntl();
  const dispatch = useDispatch<any>();
  const style = new Style();

  useEffect(() => {
    dispatch(setDelivrableAction(deliveryMethod));
  }, [deliveryMethod]);

  return (
    <div>
      {/* 送餐方式 title */}
      <div
        className="d-flex gap-1 align-items-center"
        style={{
          color: blackColor,
          fontSize: '14px',
          marginTop: '10px',
        }}
      >
        <FormattedMessage id="uberDirect.deliveryMethod" />
      </div>

      {/* 送餐方式 選擇 */}
      <div className="mt-1 d-flex justify-content-between">
        {/* 在門口碰面 */}
        <div style={{ width: '50%', textAlign: 'left', position: 'relative' }}>
          <button
            className={
              deliveryMethod
                ? 'btn btn-lg delivery-method circle-check circle-check-img'
                : 'btn btn-lg delivery-method circle-check'
            }
            style={
              deliveryMethod
                ? {
                    border: `1px solid ${style.getUiConfig().greenColor}`,
                    color: `${style.getUiConfig().greenColor}`,
                    width: '98%',
                  }
                : {
                    border: `1px solid ${style.getUiConfig().gray2Color}`,
                    color: `${style.getUiConfig().gray2Color}`,
                    width: '98%',
                  }
            }
            type="button"
            onClick={() => setDeliveryMethod(true)}
          >
            <div>
              {deliveryMethod ? (
                <img
                  style={{ width: '20%' }}
                  src={img.icon.atTheDoorGreen}
                  alt=""
                />
              ) : (
                <img
                  style={{ width: '20%' }}
                  src={img.icon.atTheDoorGray}
                  alt=""
                />
              )}
            </div>
            <div
              style={
                deliveryMethod
                  ? {
                      fontSize: '14px',
                      color: `${style.getUiConfig().greenColor}`,
                    }
                  : {
                      fontSize: '14px',
                      color: `${style.getUiConfig().gray3Color}`,
                    }
              }
            >
              <FormattedMessage id="uberDirect.deliverableAction.deliverable_action_meet_at_door" />
            </div>
          </button>
        </div>
        {/*  放門口 */}
        <div style={{ width: '50%', textAlign: 'right', position: 'relative' }}>
          <button
            className={
              !deliveryMethod
                ? 'btn btn-lg delivery-method circle-check circle-check-img'
                : 'btn btn-lg delivery-method circle-check'
            }
            style={
              !deliveryMethod
                ? {
                    border: `1px solid ${style.getUiConfig().greenColor}`,
                    color: `${style.getUiConfig().greenColor}`,
                    width: '98%',
                  }
                : {
                    border: `1px solid ${style.getUiConfig().gray2Color}`,
                    color: `${style.getUiConfig().gray2Color}`,
                    width: '98%',
                  }
            }
            type="button"
            onClick={() => setDeliveryMethod(false)}
          >
            <div>
              {!deliveryMethod ? (
                <img
                  style={{ width: '20%' }}
                  src={img.icon.putTheDoorGreen}
                  alt=""
                />
              ) : (
                <img
                  style={{ width: '20%' }}
                  src={img.icon.putTheDoorGray}
                  alt=""
                />
              )}
            </div>
            <div
              style={
                !deliveryMethod
                  ? {
                      fontSize: '14px',
                      color: `${style.getUiConfig().greenColor}`,
                    }
                  : {
                      fontSize: '14px',
                      color: `${style.getUiConfig().gray3Color}`,
                    }
              }
            >
              <FormattedMessage id="uberDirect.deliverableAction.deliverable_action_leave_at_door" />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}

DeliveryMethodSelector.propTypes = {
  deliveryMethod: PropTypes.bool.isRequired,
  setDeliveryMethod: PropTypes.func.isRequired,
};

export default DeliveryMethodSelector;
